import { IRest } from "./rest.interface";

export class Phrase implements IRest {
    className = 'Frase Motivacional';

    id!: number;
    text!: string;
    author!: string;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            id: this.id || undefined,
            text: this.text,
            author: this.author
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.id = data['id'] || 0;
            this.text = data['text'] || '';
            this.author = data['author'] || '';
        }
        return this;
    }

}